export default "__VITE_ASSET__DUbJ_Ad$__"